// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Ac5V","bigColWidth":"Table_bigColWidth__8ACXt","biggerColWidth":"Table_biggerColWidth__3rX9S","row":"Table_row__1M5RE","col":"Table_col__24sn1"};